import {Heading, HStack, VStack} from 'platform/foundation';
import styled, {css} from 'styled-components';

import {ReactElement} from 'react';

import {Nullish, TestIdProps} from 'shared/web';

import {Flag, FlagProps} from '../Flag/Flag';

export interface CardContainerProps extends TestIdProps {
  heading: string;
  children?: ReactElement | ReactElement[];
  flag?: FlagProps | Nullish;
  isWithGradient?: boolean | Nullish;
}

const CustomBox = styled.div<{isWithGradient?: boolean | Nullish}>`
  position: relative;
  border-top-right-radius: ${({theme}) => theme.radii.medium};
  border-bottom-right-radius: ${({theme}) => theme.radii.medium};
  ${({isWithGradient}) =>
    isWithGradient &&
    css`
      background: linear-gradient(
        110deg,
        rgba(255, 255, 255, 1) 0%,
        rgba(255, 255, 255, 1) 75%,
        rgba(63, 196, 255, 0.175) 100%
      );
    `}
  overflow: hidden;
`;

export function CardContainer(props: CardContainerProps) {
  return (
    <CustomBox isWithGradient={props.isWithGradient}>
      <VStack spacing={8}>
        <HStack align="center" spacing={4}>
          <Heading size={2}>{props.heading}</Heading>
          {props.flag && <Flag {...props.flag} />}
        </HStack>
        <VStack>{props.children}</VStack>
      </VStack>
    </CustomBox>
  );
}
